import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Grid } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'

interface AnalyteInfoMessageProps {
  analytes: string[]
}
const useStyles = makeStyles((theme: Theme) => {
  return {
    infoMessage: {
      margin: theme.spacing(4, 0),
    },
  }
})
const AnalyteInfoMessage: React.FC<AnalyteInfoMessageProps> = ({
  analytes,
}) => {
  const classes = useStyles()
  const hasAsteriskInAnalytes = analytes.find((analyte) =>
    analyte.includes('*')
  )
  return hasAsteriskInAnalytes ? (
    <Grid className={classes.infoMessage} item xs={12}>
      *
      <FormattedMessage
        id="MILLIPLEX_ASTERISK_INFO"
        defaultMessage="For Humanized Mouse Panel (HUMU-210K) Only"
      />
    </Grid>
  ) : (
    <></>
  )
}

export default AnalyteInfoMessage
